<template>
    <div class="h-full w-full">
        <router-view></router-view>
    </div>
</template>
